import { useState } from 'react'
import { useIntl } from '@/intl'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    title: translate({ id: 'sms4.settings.communication.notifications.twoDaysSettings' }),

    description: translate({
      id: 'sms4.settings.communication.notifications.twoDaysSettings.description',
    }),

    disableDescription: translate({
      id: 'sms4.settings.communication.notifications.twoDaysSettings.toggle.disable',
    }),

    enableDescription: translate({
      id: 'sms4.settings.communication.notifications.twoDaysSettings.toggle.enable',
    }),
  }))

  return api
}
